import { render, staticRenderFns } from "./IntegrationBackButton.vue?vue&type=template&id=fac48698&scoped=true&"
import script from "./IntegrationBackButton.vue?vue&type=script&lang=js&"
export * from "./IntegrationBackButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac48698",
  null
  
)

export default component.exports